import type { ReactNode } from 'react';
import { StyleSheet } from 'react-native-unistyles';
import Text from '@/components/UI/Text';
import Box from '@/components/Unistyles/Box';

export default function TableEmptyState({
  message,
  children,
}: {
  message: string;
  children?: ReactNode;
}) {
  return (
    <Box
      space="xs"
      align="center"
      justify="center"
      style={styles.container}
      testID="TableEmptyState"
    >
      <Text size="sm" variant="typographySecondary" center>
        {message}
      </Text>
      {children}
    </Box>
  );
}

const styles = StyleSheet.create((theme) => ({
  container: {
    minHeight: theme.size(12),
    paddingHorizontal: theme.space(3),
    paddingVertical: theme.space(2),
  },
}));
